import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { Backdrop, CircularProgress } from "@mui/material";
import '../Explore/ExploreComponent.css';
import environment from "../../environment/environment";
import Header from "../../components/Header/Header";
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import Sidebar from "../../components/Sidebar/Sidebar";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import SignIn from "../../components/SignInComponent/SignIn";
import Footer from "../../components/Footer/Footer";
import smiley from '../../assets/img/smiley-7788483_960_720.webp';

function ExploreComponent() {
    const { tourType } = useParams();
    const [packageList, setPackageList] = useState([]);
    const [exploreDetails, setExploreDetails] = useState([]);
    const [packageItemInfo, setPackageItemInfo] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [travelDate, setTravelDate] = useState('');
    const [travelCount, setTravelCount] = useState('');
    const [message, setMessage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [errors, setErrors] = useState({});
    const [isRequestModalOpen, setIsRequestModelOpen] = useState(false);
    const [isNavigatePage, setIsnavigatePage] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isModelSign, setIsModelSign] = useState(false);
    const [packageData, setPackageData] = useState([]);
    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        getAllExpore();
    }, []);

    const onPackageClick = (event, packageItem) => {
        setIsnavigatePage(true);
        setIsRequestModelOpen(false);
        if (isRequestModalOpen === false && isNavigatePage === true) {
            const data = {
                packageInfo: packageItem
            }
            navigate(`/package-details/:${packageItem.packageUID}`);
        }
    }
    const handleCancel = () => {
        setIsModalOpen(false);
        setFullName('');
        setEmail('');
        setMobileNo('');
        setTravelDate('');
        setTravelCount('');
        setMessage('');
        setErrors({});
    }

    const requestCallBack = (item) => {
        setPackageItemInfo(item);
        setIsModalOpen(true);
        setIsnavigatePage(false);
    }
    const getAllExpore = () => {
        setIsLoading(true);
        axios({
            url: `${environment.config.apiBaseUrl}route/getExploreByName?exploreName=${tourType}`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data && res.data.exploreList) {
                    const allPackages = res.data.exploreList.flatMap(explore => explore.packageList || []);
                    setExploreDetails(allPackages);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                }
            })
            .catch((err) => {
                console.error("Error fetching tours", err);
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            });
    }

    const handleChange = (field, value) => {
        switch (field) {
            case 'fullName':
                setFullName(value);
                break;
            case 'email':
                setEmail(value);
                break;
            case 'mobileNo':
                setMobileNo(value);
                break;
            case 'travelDate':
                setTravelDate(value);
                break;
            case 'travelCount':
                setTravelCount(value);
                break;
            case 'message':
                setMessage(value);
                break;
            default:
                break;
        }
        if (errors[field]) {
            setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
        }
    };
    const sendEnquiry = () => {
        if (!validateForm()) {
            toast.error('Please Enter Valid Details To Connect With An Experts!');
            return;
        }
        const requestBody = {
            "fullName": fullName,
            "email": email,
            "phoneNumber": mobileNo,
            "travelDate": travelDate,
            "travellerCount": travelCount,
            "message": message,
            "type": "website"
        };

        setIsModalOpen(true);
        axios({
            url: `${environment.config.apiBaseUrl}enquiry/createEnquiryDeatils`,
            method: "POST",
            headers: {
                authorization: "your token comes here",
            },
            data: requestBody
        })
            .then((res) => {
                setIsModalOpen(false);
                if (res && res.data) {
                    document.getElementById("exampleModal").classList.remove("show", "d-block");
                    document.querySelectorAll(".modal-backdrop")
                        .forEach(el => el.classList.remove("modal-backdrop"))
                    toast.success('Your Equiry Details Added Successfully Our Team Will Contact You Soon!')
                }
                getAllExpore();
            })
            .catch(() => { setIsModalOpen(false); });
        setFullName('');
        setEmail('');
        setMessage('');
        setTravelCount('');
        setTravelDate('');
        setMessage('');
        setMobileNo('');
    };
    const validateForm = () => {
        const newErrors = {};
        if (!fullName.trim()) newErrors.fullName = 'Full Name is required';
        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Valid Email is required';
        }
        if (!mobileNo.trim()) {
            newErrors.mobileNo = 'Mobile No. is required';
        } else if (!/^\d{10}$/.test(mobileNo)) {
            newErrors.mobileNo = 'Mobile No. must be exactly 10 digits';
        }
        if (!travelDate) newErrors.travelDate = 'Travel Date is required';
        if (!travelCount) newErrors.travelCount = 'Traveller Count is required';
        if (!message.trim()) newErrors.message = 'Message is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSignInUser = (data) => {
        setUserDetails(data);
    }

    const handleClose = (data) => {
        if (!data) {
            setIsModelSign(false);
        }
    };

    const handleBookOnline = (item) => {
        setIsLoading(true);
        axios({
            url: `${environment.config.apiBaseUrl}package/getTourPackage?packageUID=${item.packageUID}`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        }).then((res) => {
            const fetchedData = res.data[0];
            setPackageData(res.data[0]);
            let accessToken = localStorage.getItem("token");
            if (accessToken) {
                setTimeout(() => {
                    setIsLoading(false);
                    navigate('/booking', { state: { packageData: fetchedData } });
                })

            } else {
                setTimeout(() => {
                    setIsLoading(false);
                    setIsModelSign(true);
                })
            }
        })
    }
    return (
        <>
            <div className="stickyheader">
                <Header></Header>
                <NewNavBar className='newnavbartoggle' />
            </div>
            <Sidebar className='sidebartoggle' />
            {isLoading &&
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backdropFilter: "blur(5px)",
                        backgroundColor: "rgba(0, 0, 0, 0.4)"
                    }}
                    open={isLoading}
                >
                    <CustomSpinner color="inherit" />
                </Backdrop>
            }
            <div>
                <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-indicators indicator-tab">
                        {exploreDetails?.map((_, index) => (
                            <button
                                key={`indicator-${index}`}
                                type="button"
                                data-bs-target="#carouselExampleCaptions"
                                data-bs-slide-to={index}
                                className={index === 0 ? "active" : ""}
                                aria-label={`Slide ${index + 1}`}
                                aria-current={index === 0 ? "true" : undefined}
                            ></button>
                        ))}
                    </div>
                    <div className="carousel-inner" >
                        {exploreDetails?.map((item, index) => (
                            <div
                                key={item.packageUID || index}
                                className={`carousel-item cursorpointer ${index === 0 ? "active" : ""}`}
                            >
                                <div className="bannerimg-gradient-explorepage" onClick={(event) => onPackageClick(event, item)}></div>
                                <img
                                    src={item.imageList[0].coverImage}
                                    className="d-block w-100 bannerimg-height"
                                    alt={item.packageName}
                                    onError={(e) => (e.target.src = 'fallback-image.jpg')}
                                />
                                <div className="carousel-caption bannerimg-carousel-caption-text-explorepage d-md-block">
                                    <div className="cities-bannerimg-title-explorepage" >
                                        <div>{item.packageName}</div>
                                    </div>
                                    <div className="bannerimg-carousel_packageday__bannerimg_cities-explorepage mt-1">
                                        <div>{item.packageDays} days & {item.packageNight} nights | {item.packageDays}D {item.routeName}</div>
                                    </div>
                                    <div className="prices-explorepage">
                                        <b className="carousel_packageday__bannerimg_cities_prices-explorepage me-2" style={{ color: '#fff099' }}>
                                            INR {new Intl.NumberFormat('en-IN').format(item.packageWithDiscountPrices)}
                                        </b>
                                        <span className="bannerimg-carousel_packageday__bannerimg_cities_prices_discount-explorepage">
                                            INR {new Intl.NumberFormat('en-IN').format(item.packagePrices)}
                                        </span>
                                    </div>
                                    {item.packageType === 'Price' ? (
                                        <button
                                            type="button"
                                            className="btn btn-color"
                                            style={{ backgroundColor: '#ffbc23', border: 'none', color: '#2d2b29', width: '200px', zIndex: 7 }}
                                            onClick={() => handleBookOnline(item)}
                                        >
                                            Book Now
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-color"
                                            style={{ backgroundColor: '#fff099', border: 'none', color: '#2d2b29', width: '200px', zIndex: 7 }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"
                                            onClick={() => requestCallBack(item)}
                                        >
                                            Request Callback
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button
                        className="carousel-control-prev bannerimg-carousel-control-prev-explorepage"
                        type="button"
                        data-bs-target="#carouselExampleCaptions"
                        data-bs-slide="prev"
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                        className="carousel-control-next bannerimg-carousel-control-next-explorepage"
                        type="button"
                        data-bs-target="#carouselExampleCaptions"
                        data-bs-slide="next"
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div className="container">
                <div className="tour_divider__line_01"></div>
                <div className="staff_handpicked__container_body">
                    <div className="staff_handpicked_title">Explore <span>Packages</span></div>
                    <div className="staff_handpicked_title_sub_title">Curated with expertise</div>
                </div>
                <div className="ProductCarousel_wrapper__W201C  undefined ">
                    {exploreDetails && exploreDetails.length === 0 ? (
                        <div> No packages available for this route...!</div>
                    ) : (
                        exploreDetails && exploreDetails.map((item) => (
                            <div key={item.id} className="ProductCarousel_card GenericCarousel_genericCarouselContainer__Uavmv ProductCarousel_carouselWrapperclassName__Kga_o">
                                <div className="GenericCarousel_genericCarouselItemsContainer__pCJXc ProductCarousel_carouselContainerclassName__wZlkB">
                                    <div className="ProductCarousel_productCardContainer__95wik ProductCarousel_productCardWrapper__g_GKA undefined">
                                        <div className="product-card-component HandPickedProductCard_wrapper__6ih7N false">
                                            <div className="HandPickedProductCard_topSection__leG_8 cursorpointer" onClick={(event) => onPackageClick(event, item)}>
                                                <div className="HandPickedProductCard_bookingCountTag__lFPoH "><svg
                                                    xmlns="http://www.w3.org/2000/svg" width="18" height="13" color="#2d2b29" viewBox="0 0 18 13"
                                                    fill="#2d2b29">
                                                    <path
                                                        d="M8.63555 9.92222C8.63861 9.92579 8.64225 9.92862 8.64626 9.93056C8.65027 9.93249 8.65456 9.93349 8.65891 9.93349C8.66325 9.93349 8.66755 9.93249 8.67155 9.93056C8.67556 9.92862 8.6792 9.92579 8.68226 9.92222L13.9608 3.79711C13.9907 3.76237 13.9909 3.7274 13.9614 3.6922L12.4031 1.86843C12.3947 1.85861 12.3887 1.84645 12.3856 1.83314C12.3825 1.81982 12.3824 1.8058 12.3854 1.79244C12.3883 1.77908 12.3942 1.76684 12.4025 1.7569C12.4107 1.74696 12.421 1.73966 12.4324 1.73573C14.241 1.1234 16.071 0.547434 17.9223 0.0078278C17.9423 0.00180645 17.9551 -0.000741092 17.9607 0.00018527C17.9922 0.00389072 18.0048 0.0217235 17.9984 0.053683C17.5484 2.20238 17.0661 4.34135 16.5515 6.47059C16.5319 6.55211 16.496 6.56346 16.4437 6.50464L14.8315 4.69267C14.821 4.68076 14.8069 4.67415 14.7922 4.67428C14.7775 4.67441 14.7634 4.68127 14.7531 4.69337C12.992 6.73692 11.2283 8.78395 9.462 10.8345C9.18412 11.1568 8.90265 11.6828 8.42654 11.4431C8.35308 11.406 8.25426 11.3148 8.1301 11.1693C7.19625 10.0785 6.24803 8.97802 5.28543 7.86778C5.25829 7.83675 5.23134 7.83675 5.20459 7.86778C3.87308 9.40971 2.53679 10.9614 1.19571 12.5227C1.00726 12.7423 0.86812 12.8782 0.778288 12.9306C0.230915 13.2481 -0.273938 12.4026 0.16983 11.8877C1.67341 10.1443 3.17599 8.39974 4.67757 6.65401C4.92611 6.36568 5.10877 6.18087 5.44174 6.31427C5.52718 6.34855 5.6226 6.42798 5.728 6.55258C6.6914 7.68922 7.66058 8.81244 8.63555 9.92222Z"
                                                        fill="white"></path>
                                                </svg><span>128 booked in last 1 week</span></div>
                                                {item.imageList.map((element) => (
                                                    <>
                                                        <div className="HandPickedProductCard_imageBox__xU0qW HandPickedProductCard_redBorder__NVuRv" style={{ position: 'relative' }}>
                                                            <span
                                                                style={{
                                                                    boxSizing: 'border-box',
                                                                    display: 'block',
                                                                    overflow: 'hidden',
                                                                    width: 'initial',
                                                                    height: 'initial',
                                                                    background: 'none',
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    bottom: 0,
                                                                    right: 0,
                                                                }}
                                                            >
                                                                <img
                                                                    data-gumlet="true"
                                                                    decoding="async"
                                                                    data-nimg="fill"
                                                                    src={element.coverImage}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                        bottom: 0,
                                                                        right: 0,
                                                                        boxSizing: 'border-box',
                                                                        padding: 0,
                                                                        border: 'none',
                                                                        margin: 'auto',
                                                                        display: 'block',
                                                                        width: 0,
                                                                        height: 0,
                                                                        minWidth: '100%',
                                                                        maxWidth: '100%',
                                                                        minHeight: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'cover',
                                                                        backgroundSize: 'cover',
                                                                        backgroundPosition: '0% 0%',
                                                                        backgroundImage: `url(${item.imageList.coverImage})`,
                                                                    }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: 0,
                                                                        left: 0,
                                                                        width: '100%',
                                                                        height: '60%',
                                                                        background: 'linear-gradient(to top, rgba(0, 0, 0, 1) 50%, transparent 100%)',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                            </span>
                                                        </div>
                                                    </>
                                                ))
                                                }
                                            </div>
                                            <div className="HandPickedProductCard_bottomBox__0_otq">
                                                <h3 className="HandPickedProductCard_name__BvJsb"><a style={{ color: '#fff', textDecoration: 'none' }}
                                                >{item.packageName}</a></h3>
                                                <div className="HandPickedProductCard_firstRow__t3RHF">
                                                    <div className="HandPickedProductCard_duration__Jck7N">{item.packageDays}days &amp; {item.packageNight} nights</div>
                                                    <div className="HandPickedProductCard_reviewBox__pFL3A">
                                                        <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            viewBox="0 0 16 16" fill="none">
                                                            <path
                                                                d="M15.4829 5.63406L10.6864 4.90408L8.54222 0.352135C8.48365 0.227506 8.38731 0.126615 8.26829 0.0652895C7.96981 -0.0890138 7.6071 0.0395723 7.45786 0.352135L5.3137 4.90408L0.517213 5.63406C0.384974 5.65384 0.26407 5.71912 0.171503 5.81803C0.0595945 5.93848 -0.0020722 6.10053 5.31712e-05 6.26856C0.00217854 6.4366 0.0679221 6.59688 0.182838 6.71418L3.65316 10.2572L2.83328 15.2602C2.81405 15.3766 2.82635 15.4963 2.86878 15.6057C2.91121 15.7151 2.98207 15.8099 3.07333 15.8793C3.16459 15.9488 3.27259 15.99 3.38509 15.9984C3.4976 16.0068 3.6101 15.982 3.70983 15.9269L8.00004 13.5648L12.2902 15.9269C12.4074 15.9922 12.5434 16.0139 12.6737 15.9902C13.0024 15.9308 13.2235 15.6044 13.1668 15.2602L12.3469 10.2572L15.8172 6.71418C15.9117 6.61724 15.974 6.49064 15.9929 6.35216C16.0439 6.00597 15.8135 5.68549 15.4829 5.63406Z"
                                                                fill="#fff"></path>
                                                        </svg></div>
                                                        <div className="HandPickedProductCard_reviewRating__JrZeG">4.6</div>
                                                        <div className="HandPickedProductCard_reviewRatingCount__eZWOp">(
                                                            890
                                                            )</div>
                                                    </div>
                                                </div>
                                                <div className="HandPickedProductCard_divider__nHZwD"></div>
                                                <div className="HandPickedProductCard_priceContainer__C_6wk">
                                                    <div className="HandPickedProductCard_actualPrice__ozQcg">INR{item.packageWithDiscountPrices}</div>
                                                    <div className="HandPickedProductCard_strikeThroughPrice__3piVb">INR{item.packagePrices}</div><span
                                                        className="HandPickedProductCard_savePriceLeftBorderIcon__Kglze"><svg width="4"
                                                            height="24" viewBox="0 0 4 24" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M2.65992 3L0 6L2.65992 9L0 12L2.65992 15L0 18L2.65992 21L0 24H3.5V0H0L2.65992 3Z"
                                                                fill="rgba(255, 255, 255, 0.3)"></path>
                                                        </svg></span>
                                                    <div className="HandPickedProductCard_savePrice__ZVtvZ">SAVE
                                                        <div className="">INR{item.savePrices}</div>
                                                    </div><span className="HandPickedProductCard_savePriceRightBorderIcon__RYt3z"><svg
                                                        width="4" height="24" viewBox="0 0 4 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M2.65992 3L0 6L2.65992 9L0 12L2.65992 15L0 18L2.65992 21L0 24H3.5V0H0L2.65992 3Z"
                                                            fill="rgba(255, 255, 255, 0.3)"></path>
                                                    </svg></span>
                                                </div>
                                                <div className="col button-display-line">
                                                    <a href="#" className="btn btn-outline-warning btn-color-call" style={{ color: '#2d2b29' }}>
                                                        <i className="bi bi-telephone"></i>
                                                    </a>
                                                    {item.packageType === "Price" ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-color"
                                                            style={{ backgroundColor: '#ffbc23', border: 'none', color: '#2d2b29' }}
                                                            onClick={() => handleBookOnline(item)}
                                                        >
                                                            Book Now
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-color"
                                                            style={{ backgroundColor: '#fff099', border: 'none' }}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#exampleModal"
                                                            onClick={() => requestCallBack(item)}
                                                        >
                                                            Request Callback
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <div className="mt-5">
                <Footer />
            </div>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-down">
                    <div className="modal-content modal-content-overflow">
                        <div className="modal-header">
                            <div className="container modal-heading-section">
                                <div className="row">
                                    <div className="col-2 me-1">
                                        <img src={packageItemInfo && packageItemInfo?.imageList[0]?.coverImage} alt="" className="rounded mx-auto d-block " width="50"
                                            height="50" />
                                    </div>
                                    <div className="col-9">
                                        <h5 className="card-text bold" style={{ fontSize: '12px' }}>{packageItemInfo?.packageName}</h5>
                                        <p className="card-text">
                                            <b className="me-2 package-title-prices">INR {packageItemInfo?.packageWithDiscountPrices || 0} </b>
                                            <span className="package-price-decoration me-1">INR
                                                {packageItemInfo?.packagePrices || 0}</span>
                                            <span className="title-prices">
                                                SAVE INR   {packageItemInfo?.savePrices || 0}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="col-1">
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="customer-close-btn"
                                onClick={handleCancel}
                                data-bs-dismiss="modal"
                            >
                                {" "}
                                &times;
                            </button>
                        </div>
                        <div className="modal-body">
                            <>
                                {isLoading &&
                                    <Backdrop
                                        sx={{
                                            color: "#fff",
                                            zIndex: (theme) => theme.zIndex.drawer + 1,
                                            backdropFilter: "blur(5px)",
                                            backgroundColor: "rgba(0, 0, 0, 0.4)"
                                        }}
                                        open={isLoading}
                                    >
                                        <CustomSpinner color="inherit" />
                                    </Backdrop>
                                }
                                <form className="form-modal-wraaper mt-1">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
                                            placeholder="Full Name"
                                            value={fullName}
                                            onChange={(e) => handleChange('fullName', e.target.value)}
                                        />
                                        <label>Full Name *</label>
                                        {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="name@example.com"
                                            value={email}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                        />
                                        <label>Email* </label>
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.mobileNo ? 'is-invalid' : ''}`}
                                            placeholder="+91 xxx xxxx xxx"
                                            value={mobileNo}
                                            pattern="\d{10}"
                                            minLength={10}
                                            maxLength={10}
                                            onChange={(e) => handleChange('mobileNo', e.target.value)}
                                        />
                                        <label>Mobile No.*</label>
                                        {errors.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>}
                                    </div>
                                    <div className="row align-self-center">
                                        <div className="col-md-6 mt-1">
                                            <div className="form-floating mb-3">
                                                <input
                                                    type="date"
                                                    className={`form-control ${errors.travelDate ? 'is-invalid' : ''}`}
                                                    placeholder="Travel Date"
                                                    value={travelDate}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    max={new Date(new Date().getFullYear() + 1, 11, 31).toISOString().split('T')[0]} // Setting max to last day of next year
                                                    onChange={(e) => handleChange('travelDate', e.target.value)}
                                                />
                                                <label>Travel Date*</label>
                                                {errors.travelDate && <div className="invalid-feedback">{errors.travelDate}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-1">
                                            <div className="form-floating mb-3">
                                                <input
                                                    type="number"
                                                    className={`form-control ${errors.travelCount ? 'is-invalid' : ''}`}
                                                    placeholder="Traveller Count"
                                                    value={travelCount}
                                                    onChange={(e) => handleChange('travelCount', e.target.value)}
                                                    min={1}
                                                    max={5}
                                                />
                                                <label>Traveller Count*</label>
                                                {errors.travelCount && <div className="invalid-feedback">{errors.travelCount}</div>}
                                            </div>
                                        </div>
                                        <div className="form-floating mb-3">

                                            <textarea
                                                className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                                placeholder="Message"
                                                value={message}
                                                rows={4}
                                                onChange={(e) => handleChange('message', e.target.value)}
                                                style={{ minHeight: '100px' }}
                                            />
                                            <label className="message-placeholder">Your Requirements *</label>
                                            {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                        </div>
                                    </div>
                                </form>
                            </>
                        </div>
                        <hr className="mt-margin" />
                        <div className="modal-footer">
                            <button type="button" className="btn btn-color bt-width" style={{ backgroundColor: '#fff099', border: 'none' }} onClick={sendEnquiry}>Connect with an Expert</button>
                        </div>
                    </div>
                </div>
            </div>
            {
                isModelSign && (
                    <>
                        <div>
                            <SignIn isModelSign={isModelSign} closePopup={handleClose} userDetais={onSignInUser}

                                isBookOnline={true} packageItemInfo={packageData}></SignIn>

                        </div>
                    </>
                )
            }
        </>
    );
}
export default ExploreComponent;
